export default __webpack_public_path__ + "static/media/raebe-raebeliechtli.5701d3b3.webp";